import * as yup from 'yup'

import {Jurisdiction} from '@/utils/countries/constants'
import {renewalBodySchema} from '@/utils/validations/common/trademarkRenewal'

export enum TrademarkRenewalPrefillSource {
  Pricing = 'pricing',
}

export type TrademarkRenewalTrademarkDetails = {
  uuid?: string // client-generated, used as a stable React key across add/remove operations, stripped before saving
  jurisdiction: Jurisdiction
  registration_number: string
  classes_count: number
  website: string | null
}

export type TrademarkRenewalFields = Omit<
  yup.InferType<typeof renewalBodySchema>,
  'jurisdictions' | 'trademark_details' | 'note'
> & {
  jurisdictions: Jurisdiction[]
  trademark_details: TrademarkRenewalTrademarkDetails[]
  note: string
}
